/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Required_Create_TemplatesInputs */



/**
* | output |
* | --- |
* | "Compliance must be enabled to create templates." |
*
* @param {Compliance_Required_Create_TemplatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_required_create_templates = /** @type {((inputs?: Compliance_Required_Create_TemplatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Required_Create_TemplatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance muss aktiviert sein, um Templates zu erstellen.")
	return /** @type {LocalizedString} */ ("Compliance must be enabled to create templates.")
});